import React from 'react';

class PrivacyText extends React.Component {
  render() {
    return (
      <div className="privacyTextPopup" onClick={this.props.handler}>
        <div className="privacyTextPopupInner">
          <div className="privacyText">
            <p>Met deze Radioplayer toepassing geeft Digitale Radio Vlaanderen (DRV) je de kans om honderden radiostations en duizenden podcasts en programma’s te (her)beluisteren.</p>
            <p>Om je de beste luisterervaring te geven, geeft DRV aan Radioplayer Worldwide (die deze Radioplayer toepassing beheert) de opdracht om gegevens over je luistergedrag te verzamelen en te verwerken. We willen even de tijd nemen om je te vertellen welke gegevens we nodig hebben en waarom, om zeker te zijn dat je akkoord bent om verder te gaan.</p>
            <ul>
              <li>De toepassing houdt een overzicht bij van de zenders waarnaar je op dit apparaat geluisterd hebt, inclusief de zenders die je als favoriet hebt aangeduid. Deze gegevens zijn nodig om de basisfunctionaliteiten van deze Radioplayer service en adequate aanbevelingen aan te bieden.</li>
              <li>De toepassing gebruikt ook je IP-adres om bij benadering je locatie te bepalen (ie. in welke stad  je je bevindt). Hierdoor zal de toepassing radiozenders aanbevelen en tonen in zoekresultaten die voor jou het meest relevant zijn op een gegeven locatie.</li>
              <li>Er wordt geregistreerd hoe lang je luistert naar stations, door een ID te maken en deze op te slaan in een zogenaamde ‘cookie’. Dit laat ons toe om het gebruik van deze Radioplayer toepassing in kaart te brengen en zodoende de luisterervaring te verbeteren.
                Deze luistergegevens kunnen in een geaggregeerde, geanonimiseerde vorm met de betrokken radiozenders gedeeld worden, om hen te helpen ook hun dienstverlening te verbeteren.</li>
              <li>Je kan de informatie die we over je luistersessies bijhouden nalezen en je akkoordverklaring met de gebruiksvoorwaarden op elk gewenst moment intrekken door hier te klikken (ons privacybeleid kan je hier vinden).
                Klik hier om de bovenstaande gebruiksvoorwaarden te aanvaarden en door te gaan met de Radioplayer toepassing.</li>
            </ul>
          </div>
          <div className="privacyTextPopupExit">
            Sluit venster
          </div>
        </div>
      </div>
    );
  }

}

export default PrivacyText;